export enum ProgramTypes {
    'CKCC' = 'CKCC',
    'VBC' = 'VBC',
    'DEF' = 'DEF'
}